import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemAoName, FormItemAoNo} from '../AO/FormChooseAo.jsx'
import Model from './ModelIe.mjs'

export const FormItemIeTitle = props => (
    <FormItemBizProp
        Model={Model}
        prop="ieTitle"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseIe(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemAoNo />
            <FormItemAoName />
            <FormItemIeTitle />
        </FormChooseDesign>
    )
}
